@if (erRedigeringsmodus()) {
  <medlem-invitasjon-rediger [invitasjon]="invitasjon()"
                             [gruppe]="gruppe()"
                             (vedLagret)="vedRedigeringFerdig()"
                             (vedAvbryt)="vedRedigeringFerdig()"/>

} @else {
  <!-- Merk at vi også har en ref til kort i komponentklassen (MedlemKortKomponent.kortKomp),
  men denne vil ikke være initialisert før AfterViewInit, har derfor også en lokal ref her (#kort)
  slik at vi har tilgang ved initiell uttegning -->
  <kort [id]="invitasjon().id" #kort>
    <div class="kontainer">
      <!-- <avatar medlem="$ctrl.invitasjon" ng-class="{'roed':$ctrl.erAvslaatt()}"></avatar>-->
      <avatar [medlem]="invitasjon()" stil="stor"/>

      <div class="informasjon">
        <p class="epost e2e-epost"
           [matTooltip]="'Invitasjon sendes til {epost}'|translate: {epost: invitasjon().epost}">
          {{ invitasjon().epost }}
        </p>
        <p class="navn e2e-navn">{{ navn() }}&nbsp;</p><!-- &nbsp; for at linjen skal oppta vertikal plass selv når navn er tomt -->
        @if (rolle() != null) {
          <p class="rolle e2e-rolle" [matTooltip]="rolle()!.periode|datoperiodeutentid">
            {{ rolle()!.tittel }}
          </p>
        } @else {
          <p class="rolle e2e-rolle" matTooltip="{{'Rolle ikke tildelt'|translate}}">
            &nbsp; <!-- &nbsp; for at linjen skal oppta vertikal plass selv når rolle ikke er satt -->
          </p>
        }

        <p class="mobilnummer e2e-mobilnummer">
          @if (invitasjon().mobilnummer) {
            <a href="tel:{{invitasjon().mobilnummer}}">
              <i class="ion-ios-telephone-outline"></i> {{ invitasjon().mobilnummer | mobilnummer }}
            </a>
          } @else {
            <i class="ion-ios-telephone-outline"></i> {{ 'Mobiltelefon ikke angitt'|translate }}
          }
        </p>
        <p class="invitasjonsstatus e2e-invitasjonsstatus">
          @switch (invitasjon().invitasjonsstatus) {
            @case (statuser.ikke_sendt) {
              <i class="ion-alert-circled"></i>
              {{ 'Invitasjon ikke sendt'|translate }}
            }
            @case (statuser.sendt) {
              {{ 'Invitasjon sendt'|translate }}
            }
            @case (statuser['avslått']) {
              {{ 'Invitasjon avslått'|translate }}
            }
          }
        </p>
      </div>

    </div>
    @if (redigeringMulig()) {
      <kort-handlinger knappejustering="luftMellom">
        <button mat-button type="button" color="primary" (click)="sendInvitasjon()">
          <mat-icon>email</mat-icon>
          @if (invitasjon().invitasjonsstatus == statuser.ikke_sendt) {
            {{ 'Send invitasjon'|translate }}
          } @else {
            {{ 'Send invitasjon på nytt'|translate }}
          }
        </button>
        <button mat-icon-button [matMenuTriggerFor]="invitasjonMeny" (click)="$event.stopPropagation()" aria-label="Meny" class="mat-medium-icon-button e2e-meny">
          <mat-icon class="material-symbols-fet">more_vert</mat-icon>
        </button>
        <mat-menu #invitasjonMeny="matMenu">
          <button mat-menu-item (click)="rediger()">
            <mat-icon>edit</mat-icon>
            {{ "Rediger invitasjon" | translate }}
          </button>
          <button mat-menu-item (click)="slettEllerAnonymiser()">
            <mat-icon fontSet="ion-ios-trash" class="mat-icon--ionic-ikon"/>
            {{ "Slett invitasjon" | translate }}
          </button>
        </mat-menu>
      </kort-handlinger>
    }
  </kort>
}

<ng-template #bekreftSlettDialogInnhold>
  <p>
    {{ 'Du er i ferd med å slette invitasjonen til'|translate }}
    <span class="std-fet">{{ invitasjon().navn }}</span>
    {{ 'i {gruppe} i {organisasjon}'|translate: {gruppe: gruppe().tittel, organisasjon: gruppe().organisasjonsnavn} }}.
  </p>
  <inline-melding type="feil">{{ 'Merk at slettingen ikke kan angres.'|translate }}</inline-melding>
</ng-template>
